import { UserX } from 'lucide-react';
import { toast } from 'sonner';

import { Button } from '../../components/Button';
import {
    useGetImpersonationStatusQuery,
    useStopImpersonationMutation,
} from './impersonation.api';

// Mounted at the top of the admin Shell so it follows the admin across
// every page. The same data shape is consumed by a client-side banner
// in the storefront — both reads come from /v2/account/impersonation.
export function ImpersonationBanner() {
    const { data: status } = useGetImpersonationStatusQuery();
    const [stopImpersonation, stopState] = useStopImpersonationMutation();

    if (!status?.active || !status.impersonatingUser) return null;

    const handleStop = async () => {
        try {
            await stopImpersonation().unwrap();
            toast.success('Iesit din impersonare.');
            // Reload so any per-page SSR data fetched as the impersonated
            // user is dropped on the floor.
            window.location.reload();
        } catch {
            toast.error('Eroare la oprire.');
        }
    };

    return (
        <div className="border-b border-solid border-amber-300 bg-amber-100 px-4 py-2 text-amber-900 dark:border-amber-700 dark:bg-amber-900/40 dark:text-amber-100">
            <div className="mx-auto flex max-w-7xl flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
                <p className="text-sm font-medium">
                    <span className="mr-1">Impersonezi:</span>
                    <span className="font-semibold">
                        {status.impersonatingUser.name || status.impersonatingUser.email}
                    </span>
                    <span className="ml-1 text-amber-800 dark:text-amber-300">
                        ({status.impersonatingUser.email})
                    </span>
                </p>
                <Button
                    variant="secondary"
                    size="sm"
                    onClick={handleStop}
                    disabled={stopState.isLoading}
                >
                    <UserX aria-hidden="true" className="h-4 w-4" />
                    Iesi din impersonare
                </Button>
            </div>
        </div>
    );
}
